/** 由 legacySafariGuard head 脚本写入 */
export function getIosMajor(): number {
  if (typeof window === 'undefined') return 0
  return (window as Window & { __MOJI_IOS_MAJOR__?: number }).__MOJI_IOS_MAJOR__ ?? 0
}

/** iOS 13 及以下：部分能力不可用，展示升级提示而非「加载失败/刷新」 */
export function isIosUpgradeRequired(): boolean {
  const v = getIosMajor()
  return v > 0 && v < 14
}

/** iOS 13 上 ECharts / 复杂 canvas 易触发运行时错误，先降级为不挂载图表 */
export function iosSupportsCharts(): boolean {
  const v = getIosMajor()
  return v <= 0 || v >= 14
}

/** 仅 iOS 13 不加载雷达 iframe（HTTP/HTTPS 预览与正式环境均允许，点击外链跳转不受影响） */
export function iosSupportsRadarIframe(): boolean {
  const v = getIosMajor()
  return v <= 0 || v >= 14
}

export function isSecurityErrorMessage(msg: string): boolean {
  return /securityerror/i.test(msg) && /insecure|operation/i.test(msg)
}
